import WatchPage from './WatchPage';
import WatchPageContainer from './WatchPage.container';

export default WatchPageContainer(WatchPage);
